<app-space-item-popover [spaceItem]="spaceItem">
<div class="app-navbar-item flex-center px-1 py-3 h-100 d-flex flex-center">
  <!--begin::Navbar link-->
  <a (click)="onItemClick()" [class.active]="isActive"  class="btn btn-icon btn-circle hover-scale btn-active-light border-active border-gray-300 border border-3">
    <!-- <img
      [src]="spaceItem.logo"
      class="mw-25px"
      alt=""
    /> -->
  </a>
  <!--end::Navbar link-->
</div>


</app-space-item-popover>
